<div class="ab-list-item-inner flex w-100 activity-type--canvass-attempt">
  <span class="ab-list-item__icon">
    <i class="icon fal fa-comments-question"></i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span> logged a conversation for
      <app-activity-target-link [target]="item.target">{{item?.target | fullName}}</app-activity-target-link>
    </div>
    <div class="details">
      <span class="tag">{{getContactType()}}</span>

      <span class="tag-type meta" *ngIf="isPhone() || isEmail()">
        ({{getHomeWorkMobile()}}):
      </span>

      <strong class="response">
        <span *ngIf="isPhone()">{{item.payload?.phoneNumber?.number | phone}}</span>
        <span *ngIf="isEmail()">{{item.payload?.email?.email}}</span>
      </strong>

      <span class="response-status meta ml-0025"
            *ngIf="getStatus() === 'do_not_contact'">
        <i class="fas fa-ban color--red pair__verified"
           matTooltip="Do not contact"
           matTooltipPosition="above"></i>
      </span>
      <span class="response-status meta ml-0025"
            *ngIf="getStatus() === 'verified'">
        <i class="far fa-check pair__verified"
           matTooltip="Confirmed"
           matTooltipPosition="above"></i>
      </span>
      <span class="response-status meta ml-0025"
            *ngIf="getSubscribed()">
        <i class="far fa-bell-on pair__verified ml-0050"
           [matTooltip]="'Subscribed'"
           [matTooltipPosition]="'left'"></i>
      </span>

      <div *ngIf="item.payload.note">Contact Note: {{item.payload.note}}</div>
    </div>
  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
